<template>
  <div class="content">
    <div class="title">影票订单</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="first"></el-tab-pane>
      <el-tab-pane label="拦截中" name="second"></el-tab-pane>
      <el-tab-pane label="拦截成功" name="third"></el-tab-pane>
      <el-tab-pane label="拦截失败" name="fourth"></el-tab-pane>
      <el-tab-pane label="取消拦截" name="fourth"></el-tab-pane>
    </el-tabs>
    <Search :searchForm="searchForm" :searchList="searchList"></Search>
    <!--    表格-->
    <el-table
      class="table"
      v-loading="searchForm.Loading"
      :data="tableList"
      border
      highlight-current-row
      style="width: 100%;"
      header-row-class-name="header"
      max-height="250"
    >
      <el-table-column
        v-for="(item,index) in tableData"
        :key="index"
        :prop="item.text"
        :label="item.text"
        align="center"
      >
        <template slot-scope="{row}">
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="{row}">
          <span class="add" @click="compile(row)">编辑</span>
          <span class="delete" @click="deleteList(row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="searchForm.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total">
    </el-pagination>
    <el-dialog
      title="设为总监"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div class="dialog">
        <div class="dialog-text">确认取消拦截？</div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisible = false">取消</div>
          <div class="button-success" @click="dialogVisible = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <!--   影票详情-->
    <el-dialog
      title="影票详情"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <div class="detail">
        <div style="margin-right: 54px">
          <div class="detail-item">
            <div class="item-text">影票图片</div>
            <img src="" alt="">
          </div>
          <div class="detail-item">
            <div class="item-text">影片名称</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">反映时间</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">影院</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">取票码</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">实际座位</div>
            <div class="item-span">影片名称</div>
          </div>
        </div>
        <div>
          <div class="detail-item">
            <div class="item-text">座位</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">下单时间</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">厅/语言</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">城市</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">地址</div>
            <div class="item-span">影片名称</div>
          </div>
          <div class="detail-item">
            <div class="item-text">取票码截图</div>
            <div class="item-span">影片名称</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/Search";
export default {
  name: "index",
  components:{
    Search
  },
  data(){
    return{
      activeName:'first',
      searchForm: {
        number: '',
        type: '',
        isRenew: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        Loading: false
      },
      dialogVisible:false,
      searchList: [
        {
          id: 'number',
          text: '订单号',
          placeholder: '请输入订单号',
          type: 'input'
        }, {
          id: 'type',
          text: '用户昵称',
          placeholder: '请选择用户名称',
          type: 'input'
        }, {
          id: 'type',
          text: '来源平台',
          placeholder: '请选择用户名称',
          type: 'select'
        }, {
          id: 'type',
          text: '拦截状态',
          placeholder: '请选择用户名称',
          type: 'select'
        }, {
          id: 'type',
          text: '申请时间',
          placeholder: '',
          type: 'time'
        }],
      // 表头
      tableData: [
        {
          text: '序号',
          value: 'number',
        }, {
          text: '订单ID',
          value: 'typeStr',
        }, {
          text: '来源平台',
          value: 'tag',
        }, {
          text: '拦截原因',
          value: 'price',
        }, {
          text: '订单状态',
          value: 'num',
        },{
          text: '拦截状态',
          value: 'num',
        },{
          text: '失败原因',
          value: 'num',
        },{
          text: '处理时间',
          value: 'num',
        },{
          text: '申请时间',
          value: 'num',
        },{
          text: '影票信息',
          value: 'num',
        }
      ],
      tableList:[],
      currentPage:1,
    }
  },
  methods:{
    handleClick(e){
      console.log(e)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleClose(){

    }
  }
}
</script>

<style scoped lang="less">
.content{
  width: 80%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }
}
.table{
  margin-top: 30px;
}
.detail{
  display: flex;
  align-items: center;
  .detail-item{
    display: flex;
    margin-top: 20px;
    .item-text{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }
    .item-span{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}
.dialog{
  padding: 20px 80px;
  .dialog-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }
  .dialog-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    text-align: center;
  }
  .dialog-button{
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;
    .button-success{
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
    .button-cancel{
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #EEEEEE;
}
/deep/.el-tabs__item.is-active{
  color: #FF8622!important;
}
/deep/.el-tabs__active-bar{
  background-color: #FF8622!important;
}
/deep/.el-tabs__item:hover{
  color: #FF8622!important;
}
/deep/.el-table th, .el-table tr{
  background-color: #FCFAF8;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/intercept/index.vue